module.exports = __webpack_public_path__ + "static/media/new_imobiliaria_logo.8d7c437b.png";